import { render, staticRenderFns } from "./editOm.vue?vue&type=template&id=425cac34&scoped=true&"
import script from "./editOm.vue?vue&type=script&lang=js&"
export * from "./editOm.vue?vue&type=script&lang=js&"
import style0 from "./editOm.vue?vue&type=style&index=0&id=425cac34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425cac34",
  null
  
)

export default component.exports